<template>
	<div class="tokyo_tm_home">
		<div class="home_content">
			<div class="avatar">
				<div
					class="image avatar_img"
					:style="{ backgroundImage: 'url(' + src1 + ')' }"
				></div>
			</div>
			<!-- End .avatar -->
			<div class="details">
				<h3 class="name">Abdullah Gürsoy</h3>

				<h5 class="">Software Developer & Artist</h5>

				<div>
					<Social />
				</div>

				<br /><br />

				<div class="job">
					Experienced Software Engineer with over 12 years of full-stack
					development expertise across government, private, and freelance
					sectors. Proven track record in building scalable applications visited
					by millions, leading frontend teams, and delivering cross-platform
					solutions. Fulbright Scholar with a strong academic background in
					Computer Vision. Adept in JavaScript, Vue.js, Nuxt.js, Node.js,
					Laravel, PHP, and Capacitor.js.
					<br />
					<br />
					With years of experience as a full-stack developer, I confidently
					tackle challenges using JavaScript, Vue.js, Nuxt.js, Node.js,
					Capacitor.js, Laravel, and PHP.

					<div class="tokyo_tm_button">
						<div
							style="
								display: flex;
								justify-content: center;
								padding-top: 30px;
								border-radius: 10px;
							"
						>
							<a
								href="/portfolio"
								class="ib-button"
								style="
									padding: 15px 40px 15px 40px;
									width: 280px;
									text-align: center;
								"
							>
								See My Works
							</a>
						</div>
					</div>
				</div>
			</div>
			<!-- End .details -->
		</div>
	</div>
</template>

<script>
import Social from "./Social";
export default {
	components: {
		Social,
	},
	data() {
		return {
			src1: require("../assets/img/slider/1.jpg"),
		};
	},
};
</script>

<style lang="scss"></style>
